import { useSelector } from 'react-redux';
import { selectSizeA, selectSizeB, selectSizeC } from '@store/order/selectors';



const AnimalDimensions = (): JSX.Element => {

	const sizeA = useSelector(selectSizeA);
	const sizeB = useSelector(selectSizeB);
	const sizeC = useSelector(selectSizeC);

	return (
		<div className='order-summary-element'>

			<h2>Rozměry zvířete</h2>

			<div className='summary-grid'>
				
				{sizeA && sizeA > 0 &&
					<p>Délka od obojku ke špičce čumáku:</p>}
				{sizeA && sizeA > 0 &&
					<p>{`${sizeA ? sizeA : 0} cm`}</p>}
				
				<p>Obvod krku:</p>
				<p>{`${sizeB ? sizeB : 0} cm`}</p>

				<p>Výška v kohoutku:</p>
				<p>{`${sizeC ? sizeC : 0} cm`}</p>
			
			</div>

		</div>
	);
};

export default AnimalDimensions;